'use strict';
import moment from 'moment';
import {AjaxFactory, getPageFilterParams, HttpMethod} from '../../_libs/redux-observable-list';
import {ReportFormat} from '../enums/ReportFormat';

/**
 * @param {ReduxObservableListExportsOptions} options
 */
export function buildReportFactory(options) {
  return new AjaxFactory(buildReportRequestOptions(options));
}

/**
 * @param {ReduxObservableListExportsOptions} options
 * @return {AjaxFactoryOptions}
 */
export function buildReportRequestOptions(options) {
  return {
    crossDomain: options.crossDomain,
    method: HttpMethod.GET,
    useBody: false,
    url: getReportUrl(options),
    getToken: options.getToken,
    responseType: request => {
      switch (request.format) {
        case ReportFormat.CSV:
          return 'blob';

        case ReportFormat.XLSX:
          return 'json';

      }
    },
    modifyHeaders: (headers, request) => {
      if (request.format === ReportFormat.CSV) {
        headers.Accept = 'text/csv';
      }

      return headers;
    },
  };
}

/**
 * @typedef {Object} ListPageRequest
 * @property {String} [parentId]
 * @property {Number} currentPage
 * @property {Number} [pageSize]
 * @property {FilterData} filterData
 */

/**
 * @param {ReduxObservableListExportsOptions} options
 * @return {Function}
 */
export function getReportUrl(options) {
  /**
   * @param {ListPageRequest} request
   */
  return function getReportUrlCurried(request) {
    const params = `${getPageFilterParams(options, request)}&${getReportParams(options, request)}`;
    return `${options.baseApiUrl}/${getReportPath(options, request.parentId)}?${params}`;
  };
}

function getReportPath(options, parentId) {
  if (options.hasParentId) {
    return options.reportPath(parentId);
  } else {
    return options.reportPath;
  }
}

/**
 * Derive the default reportPath option from the listPath option.
 * @param {ReduxObservableListExportsOptions} options
 * @return {*}
 */
export function defaultGetReportPath(options) {
  if (options.hasParentId) {
    return parentId => `${options.listPath(parentId)}/_report`;
  } else {
    return `${options.listPath}/_report`;
  }
}

/**
 * @param {ReduxObservableListExportsOptions} options
 * @param request
 * @return {*}
 */
function getReportParams(options, request) {
  const dateFormat = encodeURIComponent("yyyy-MM-dd'T'HH:mm:ssZ");
  const extraParams = options.getParams(request);
  const tz = `tz=${moment.tz.guess()}`;

  if (extraParams && (extraParams.indexOf('dateTimeFormat') > -1 || extraParams.indexOf('dateFormat'))) {
    return `${tz}&${extraParams}`;
  } else {
    return `${tz}&dateFormat=${dateFormat}${extraParams ? '&' + extraParams : ''}`;
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux-observable-list-exports/defaultReportFactory.js